
// eslint-disable-next-line import/prefer-default-export
export const authTokenSelector = (state) => state.auth.authToken
// export const logoutMessageSelector = (state) =>  state.auth.message
export const sessionSelector = (state) =>  state.auth.isLogout